import { Pipe, PipeTransform } from '@angular/core';
import { TimeToRepairPluginService } from './timetorepair-plugin.service';

@Pipe({
    name: 'reparatorpipe',
    standalone: false
})
export class ReparatorPipe implements PipeTransform {
  public reparators: any;

  constructor(private service: TimeToRepairPluginService) {
    this.reparators = this.service.getReparators();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.reparators);
  }
}
